























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BcTableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import PaginationInterface from '@core/interfaces/pagination-interface';
import OrderingInterface from '@core/interfaces/ordering-interface';
import { SelectOptionInterface } from '@shared/interfaces/inputs';
import BcSaleDaysSyncFilters from './sale-days-sync-filters.vue';
import BcTableOrdering from '@shared/components/tables/table-ordering/table-ordering.vue';
import { BPCTableField } from '@shared/interfaces/bpc-table-interface';
import BcTable from '@shared/components/tables/table.vue';
import BcDisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import {
  PosSessionDefaultTableItemInterface,
  PosSessionSyncDefaultFilterTableInterface,
  PosSessionSyncPermissionName,
} from '@modules/accounting-integrations/interfaces/pos-session-sync';
import { posSessionSyncDisplayFields } from '@modules/accounting-integrations/config/pos_session_sync_options';
import BcSaleDaySyncDetails from './sale-day-sync-details.vue';
import BcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { AccountingIntegrationSettings } from '@accounting-integrations/interfaces/accounting-integrations';
import BcSaleDaySyncModal from './sale-day-sync-modal.vue';
import BcSaleDayMarkAsSyncedModal from './sale-day-mark-as-synced-modal.vue';

@Component({
  name: 'bc-sale-days-sync-table',
  components: {
    BcTableWrapper,
    BcSaleDaysSyncFilters,
    BcTableOrdering,
    BcTable,
    BcDisplayFieldBadge,
    BcSaleDaySyncDetails,
    BcDrawerModal,
    BcSaleDaySyncModal,
    BcSaleDayMarkAsSyncedModal,
  },
})
export default class PosSessionSyncTable extends Vue {
  @Prop({ type: String }) readonly actionsPortalTarget!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: true }) readonly showFilters!: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrdering!: boolean;
  @Prop({ type: Boolean, default: false }) readonly noCheckboxColumn!: boolean;
  @Prop({ type: String, required: true })
  readonly saleDayType: 'pos' | 'online';

  readonly pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  readonly orderByOptions: SelectOptionInterface[] = [
    {
      text: this.$t('accounting_integrations.sale_days_sync.date.label').toString(),
      value: 'date',
    },
    {
      text: this.$t('accounting_integrations.sale_days_sync.accounting_journal.label').toString(),
      value: 'accountingJournal',
    },
    {
      text: this.$t('accounting_integrations.sale_days_sync.total_sales.label').toString(),
      value: 'totalSales',
    },
    {
      text: this.$t('accounting_integrations.sale_days_sync.total_payments.label').toString(),
      value: 'totalPayments',
    },
  ];

  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };

  filters: PosSessionSyncDefaultFilterTableInterface = {
    search: null,
    validation_status: [],
    sync_status: [],
    date_from: null,
    date_to: null,
  };

  ordering: OrderingInterface = {
    order_by: 'date',
    order_direction: 'desc',
  };

  tableFields: BPCTableField[] = [
    {
      key: 'date',
      headerLabel: 'accounting_integrations.sale_days_sync.date.label',
      order: 0,
      displayType: 'date',
    },
    {
      key: 'accountingJournal',
      headerLabel: 'accounting_integrations.sale_days_sync.journal.label',
      order: 1,
    },
    {
      key: 'totalSales',
      headerLabel: 'accounting_integrations.sale_days_sync.total_sales.label',
      order: 2,
      displayType: 'currency',
    },
    {
      key: 'totalPayments',
      headerLabel: 'accounting_integrations.sale_days_sync.total_payments.label',
      order: 3,
      displayType: 'currency',
    },
    {
      key: 'validationStatus',
      headerLabel: 'accounting_integrations.sale_days_sync.validation_status.label',
      order: 4,
      displayType: 'badge',
    },
    {
      key: 'syncStatus',
      headerLabel: 'accounting_integrations.sale_days_sync.sync_status.label',
      order: 5,
      displayType: 'badge',
    },
  ];

  tableItems: PosSessionDefaultTableItemInterface[] = [];
  loading = false;
  showDetailsDrawer = false;
  selectedSessionId: number | null = null;
  checkedAllEntities = false;
  showSyncModal = false;
  showMarkAsSyncedModal = false;
  saleDayToSync: PosSessionDefaultTableItemInterface | null = null;
  saleDayToMarkAsSynced: PosSessionDefaultTableItemInterface | null = null;

  get accountingIntegrationSettings(): AccountingIntegrationSettings {
    if (this.$modulesService.hasModuleActivated('accounting_integrations')) {
      return this.$store.getters['centerSettings/accountingIntegrationSettings'];
    }

    return null;
  }

  get syncService(): string {
    return this.accountingIntegrationSettings?.sync_service;
  }

  get permissionEntityName(): string {
    return PosSessionSyncPermissionName;
  }

  get showSyncAction(): boolean {
    return (
      !this.disabled &&
      this.$authorizationService.hasPermission('sync_sale_days') &&
      this.syncService === 'exact' // For now we only have sync with exact
    );
  }
  get showMarkAsSyncedAction(): boolean {
    return (
      !this.disabled &&
      this.$authorizationService.hasPermission('sync_sale_days') &&
      this.syncService === 'exact' // For now we only have sync with exact
    );
  }

  get fieldsToShow(): BPCTableField[] {
    return [...this.tableFields].sort((f1, f2) => f1.order - f2.order);
  }

  get displayConfig() {
    return posSessionSyncDisplayFields;
  }

  get changeDetectorStr(): string {
    return [
      this.pagination?.per_page,
      this.pagination?.current_page,
      this.ordering?.order_by,
      this.ordering?.order_direction,
      this.filters?.search,
      this.filters?.validation_status,
      this.filters?.sync_status,
      this.filters?.date_from,
      this.filters?.date_to,
    ].join('--');
  }

  mounted(): void {
    this.restartFilters();
    this.getPosSessionsIfStopChanging();
  }

  restartFilters(): void {
    this.filters = {
      search: null,
      validation_status: [],
      sync_status: [],
      date_from: null,
      date_to: null,
    };
  }

  clickOnReload(): void {
    this.getPosSessionsIfStopChanging();
  }

  clickOnChangeOrderDirection(direction: string): void {
    this.ordering.order_direction = direction;
  }

  onCheckAll(val: boolean): void {
    this.checkedAllEntities = val;
  }

  clickOnView(item: PosSessionDefaultTableItemInterface): void {
    this.selectedSessionId = item.id;
    this.showDetailsDrawer = true;
  }

  clickOnBulkSync(): void {
    this.showSyncModal = true;
  }
  clickOnSync(saleDay: PosSessionDefaultTableItemInterface): void {
    this.saleDayToSync = saleDay;
    this.showSyncModal = true;
  }

  clickOnMarkAsSynced(saleDay: PosSessionDefaultTableItemInterface): void {
    this.saleDayToMarkAsSynced = saleDay;
    this.showMarkAsSyncedModal = true;
  }

  onMarkAsSyncSuccess(): void {
    this.getPosSessionsData();
  }

  onSyncProcessFinished(): void {
    this.getPosSessionsData();
  }

  closeDrawer(): void {
    this.showDetailsDrawer = false;
    this.selectedSessionId = null;
  }

  private getQueryParams() {
    return {
      order_by: this.ordering.order_by,
      order_direction: this.ordering.order_direction,
      per_page: this.pagination?.per_page,
      page: this.pagination?.current_page,
      search: this.filters.search,
      validation_status: this.filters.validation_status,
      sync_status: this.filters.sync_status,
      date_from: this.filters.date_from,
      date_to: this.filters.date_to,
    };
  }

  private async getPosSessionsIfStopChanging(): Promise<void> {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getPosSessionsData();
      }
    }, 300);
  }

  private async getPosSessionsData(): Promise<void> {
    this.loading = true;
    this.checkedAllEntities = false;

    try {
      const url = this.$bpcApiRouteHelper.getApiPath(`sales-synchronization/${this.saleDayType}`);
      const response = await this.$bpcApi.get(url, { params: this.getQueryParams() }).toPromise();

      this.tableItems = response.data;

      this.pagination = response.meta;
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error instanceof Error ? error.message : 'An error occurred';
      this.$bpcMessage.showErrorMessage({ text: errorMessage });
    } finally {
      this.loading = false;
    }
  }

  private formatAmount(value: number): string {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
    }).format(value);
  }

  @Watch('changeDetectorStr')
  onChangeDetectorStrChange(val: string): void {
    if (val) this.getPosSessionsIfStopChanging();
  }
  @Watch('saleDayType')
  onSaleDayTypeChange(): void {
    this.restartFilters();
    this.getPosSessionsData();
  }
}
